import PropTypes from 'prop-types';
import { useForm, useWatch } from 'react-hook-form';
import FormRow from '@/components/core/form/FormRow';
import { getUnitOptions } from '@/utils/pathwayUtils';
import debounce from 'debounce';
import Select from '@/components/core/form/Select';
import { FormProvider } from 'react-hook-form';
import { useEmissionTypes, useHasInternals, useUnits } from '@/stores/comparisonStore';
import { EMISSIONS_UNITS } from '@/consts';

const levelizeOptions = [
  { value: true, label: 'Per Functional Unit' },
  { value: false, label: 'Total' },
];

const emissionsUnitOptions = getUnitOptions(EMISSIONS_UNITS);

const LCAComparisonForm = ({ defaultValues, onSubmit }) => {
  const methods = useForm({ defaultValues });
  const { control, handleSubmit, register } = methods;
  const units = useUnits();
  const unitOptions = getUnitOptions(units);
  const emissionTypeOptions = useEmissionTypes();
  const hasInternals = useHasInternals();
  const debouncedSave = debounce(() => handleSubmit(onSubmit)(), 10);

  const levelize = useWatch({ control, name: 'levelize', defaultValue: defaultValues?.levelize });
  const levelized = levelize !== 'false';

  return (
    <div className="group node">
      <FormProvider {...methods}>
        <form onChange={debouncedSave}>
          <div className="mt-2 grid grid-cols-5 gap-2">
            <FormRow label="Values" name="levelize">
              <Select className="w-full truncate" name="levelize" options={levelizeOptions} />
            </FormRow>
            <FormRow label="Unit" name={levelized ? 'levelizationUnit' : 'emissionsUnit'}>
              {levelized ? (
                <Select className="w-full truncate" name="levelizationUnit" options={unitOptions} />
              ) : (
                <Select className="w-full truncate" name="emissionsUnit" options={emissionsUnitOptions} />
              )}
            </FormRow>
            <FormRow label="Y axis" name="emissionType">
              <Select className="w-full truncate" name="emissionType" options={emissionTypeOptions} />
            </FormRow>
          </div>
          <div className="flex p-2 mr-2 mt-2">
            {hasInternals && (
              <FormRow label="Add Scope 1 breakdown" name="scope1Breakdown">
                <input
                  {...register('scope1Breakdown')}
                  id="scope1Breakdown"
                  name="scope1Breakdown"
                  type="checkbox"
                  className="toggle toggle-sm toggle-success mt-1 truncate w-full"
                />
              </FormRow>
            )}
            <FormRow label="Add Scope 3 breakdown" name="scope3Breakdown">
              <input
                {...register('scope3Breakdown')}
                id="scope3Breakdown"
                name="scope3Breakdown"
                type="checkbox"
                className="toggle toggle-sm toggle-success mt-1 truncate w-full"
              />
            </FormRow>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

LCAComparisonForm.propTypes = {
  params: PropTypes.arrayOf(PropTypes.object),
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default LCAComparisonForm;
